import React from "react";
import { Link } from "@quintype/components";

import AppStore from "../../atoms/app-store";
import GooglePlay from "../../atoms/google-play";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";

import "./subscribe-card.m.css";

const SOCIAL_MEDIA_CONTENT = [
  { link: "https://www.facebook.com/deccanherald/", icon: "facebookcolorround" },
  { link: "https://twitter.com/deccanherald", icon: "twittercolorround" },
  { link: "https://www.youtube.com/channel/UCHDXXHPrz-1GVbK_qk82hBQ", icon: "youtubecolorround" },
  { link: "https://t.me/DeccanHeraldNews", icon: "telegramcolorround" },
  { link: "https://www.instagram.com/deccanherald/", icon: "instagramcolorround" }
];

const SubscribeCard = ({ story }) => {
  return (
    <div styleName="wrapper">
      <div styleName="subscribe-left">
        <span className="hide-mobile">
          <h2>Follow us on </h2>
        </span>
        <span className="hide-desktop">
          <h2>Follow </h2>
        </span>
        <div styleName="subscribe-social-icons">
          {SOCIAL_MEDIA_CONTENT?.map((item, index) => (
            <Link href={item.link} key={index} target="_blank">
              <SvgIconHandler type={item.icon} height="32px" width="32px" />
            </Link>
          ))}
        </div>
      </div>
      <div styleName="subscribe-right">
        <a
          href="https://play.google.com/store/apps/details?id=com.tpml.dh"
          target="_blank"
          styleName="app-link"
          rel="noreferrer"
        >
          <GooglePlay height="42" width="128" />
        </a>
        <a
          href="https://apps.apple.com/us/app/deccan-herald-news/id1511179557"
          target="_blank"
          styleName="app-link"
          rel="noreferrer"
        >
          <AppStore height="40" width="120" />
        </a>
      </div>
    </div>
  );
};

export default SubscribeCard;
